import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription, Observable } from 'rxjs';
import { UserService } from '../../../services/user.service'
import { AdministrationService } from '../../../services/administration.service'
import { MatSnackBar } from '@angular/material';
import { MatSort, MatDialog } from '@angular/material';
import { AddNewFareTaxDialog } from '../../administration/fare-tax-obj-id-list/dialog.addnewfaretax';
import { EditFareTaxDialog } from '../../administration/fare-tax-obj-id-list/dialog.editfaretax';

@Component({
  selector: 'app-fare-tax-obj-id-list',
  templateUrl: './fare-tax-obj-id-list.component.html',
  styleUrls: ['./fare-tax-obj-id-list.component.css']
})
export class FareTaxObjIdListComponent implements OnInit, OnDestroy {
  allSub: Subscription[] = [];
  searchFareTaxform: FormGroup;
  errorMessage: string = '';
  loading: boolean = false;
  datasource = [];
  p: number = 1;
  totalCount: number = 0;
  userName: string = '';
  screenCode: string = '';

  constructor(private administrationService: AdministrationService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private userService: UserService) {
    let user = this.userService.getUser();
    this.userName = user.username;
    this.screenCode = user.screenCode;
  }

  ngOnInit() {
    this.searchFareTaxform = new FormGroup({
      pukalNo: new FormControl({ value: '', disabled: false })
    });

    let fareTaxSearch = {
      searchValue: '',
      page: null
    }

    this.get(fareTaxSearch);
  }

  onSearch(form: FormGroup) {
    this.loading = true;
    let fareTaxSearch = {
      searchValue: this.searchFareTaxform.get('pukalNo')!.value,
      page: null
    }

    this.get(fareTaxSearch);
  }

  addNewFareTax() {
    let dialogRef = this.dialog.open(AddNewFareTaxDialog, {
      width: '60%',
      disableClose: true,
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Add successful') {
        let fareTaxSearch = {
          searchValue: '',
          page: null
        }
        this.get(fareTaxSearch);
        this.openSnackBar('New Pukal No added.', '');
      }
    });
  }

  editFareTax(fareTax: any) {
    let dialogRef = this.dialog.open(EditFareTaxDialog, {
      width: '60%',
      disableClose: true,
      data: {
        TaxId: fareTax.TaxId,
        AccNo: fareTax.Acc_No,
        FareObjId: fareTax.Fare_Obj_Id,
        TaxObjId: fareTax.Tax_Obj_Id
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Edit successful') {
        let fareTaxSearch = {
          searchValue: '',
          page: null
        }
        this.get(fareTaxSearch);
        this.openSnackBar('Changes saved.', '');
      }
    });
  }

  deleteFareTax(data: any) {
    let cfm = confirm("Are you sure you want to delete?");

    if (cfm) {
      this.loading = true;
      let fareTax = {
        TaxId: data.TaxId,
        AccNo: '',
        FareObjId: null,
        TaxObjId: null
      }

      let save_sub = this.administrationService.deleteFareTaxDetails(fareTax)
        .subscribe(
          (value) => {
            this.loading = false;
            if (value.status === 204) {

            } else if (value.status === 200) {
              let fareTaxSearch = {
                searchValue: '',
                page: null
              }
              this.get(fareTaxSearch);
              this.openSnackBar('Selected Pukal No Deleted.', '');
            } else {
              this.openSnackBar('Error adding pukal no details.', '');
            }
          },
          (error) => {
            this.loading = false;
            this.errorMessage = <any>error;
            this.openSnackBar(this.errorMessage, '');
          });

      //Adds into array for each subscribe
      this.allSub.push(save_sub);
    } else {
      this.loading = false;
    }
  }

  get(fareTaxSearch: any) {
    this.loading = true;
    let get_sub = this.administrationService.getFareTaxList(fareTaxSearch)
      .subscribe(
        (value) => {
          this.loading = false;
          if (value.status === 204) {

          } else if (value.status === 200) {
            this.datasource = value.body['taxObjList'];
            this.totalCount = this.datasource.length;
          } else {
            this.openSnackBar('Error retrieving fare tax list.', '');
          }
        },
        (error) => {
          this.loading = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(get_sub);
  }

  ngOnDestroy() {
    for (let sub of this.allSub) {
      sub.unsubscribe();
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
}
